import { styled, Theme } from "@material-ui/core";
import Box from "@material-ui/core/Box";

export default styled(Box)<Theme>(({ theme }) => ({
  marginTop: 0,
  fontSize: 26,
  lineHeight: "130%",
  fontWeight: theme.typography.fontWeightMedium,
}));
